export const GET_ACCOUNT_TOTAL = "GET_ACCOUNT_TOTAL"; //for total payment amount for delivery boy
export const GET_DELIVERY_SETTLEMENTS = "GET_DELIVERY_SETTLEMENTS";
export const GET_DELIVERY_PAYMENTS = "GET_DELIVERY_PAYMENTS";
export const GET_REST_ACCOUNT_TOTAL = "GET_REST_ACCOUNT_TOTAL";
export const GET_REST_SETTLEMENTS = "GET_REST_SETTLEMENTS";
export const GET_REST_PAYMENTS = "GET_REST_PAYMENTS";
